// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"211":"925e1f81","977":"08ccab32"}[chunkId] + ".chunk.js";
};